// src/components/Footer.jsx
import React from "react";
import styled from "styled-components";
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";

const FooterContainer = styled.footer`
  background: ${({ themeColor }) => themeColor || "#f56620"};
  color: #ffffff;
  padding: 0.5rem 1.5rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    text-align: center;
  }
`;

const SocialSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  justify-self: start;
`;

const SocialTitle = styled.h4`
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.5px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 0.8rem;
`;

const IconLink = styled.a`
  color: ${({ $brandColor }) => $brandColor || "#64748b"} !important;
  background: #ffffff !important;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  font-size: 0.9rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover {
    background: ${({ $brandColor }) => $brandColor || "#64748b"} !important;
    color: #ffffff !important;
    transform: translateY(-2px) scale(1.08);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
  }
`;

const CopyrightSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
`;

const Copyright = styled.p`
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.95;
  text-align: center;
`;

const Divider = styled.div`
  width: 1px;
  height: 32px;
  background: #ffffff;
  opacity: 0.25;
  margin: 0 1.5rem;

  @media (max-width: 768px) {
    width: 80%;
    height: 1px;
    margin: 0.5rem 0;
  }
`;

const RightSpacer = styled.div`
  width: 100%;
`;

const Footer = ({ themeColor, socialMediaEnabled }) => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <FaFacebookF />,
      url: "https://facebook.com/CLIDESafety",
      label: "Facebook",
      brandColor: "#1877F2",
    },
    {
      icon: <FaTwitter />,
      url: "https://twitter.com/clide_analyser",
      label: "Twitter",
      brandColor: "#1DA1F2",
    },
    {
      icon: <FaYoutube />,
      url: "https://www.youtube.com/@clide2704",
      label: "YouTube",
      brandColor: "#FF0000",
    },
    {
      icon: <FaLinkedinIn />,
      url: "https://www.linkedin.com/showcase/clideanalysersafetyapp/",
      label: "LinkedIn",
      brandColor: "#0077B5",
    },
    {
      icon: <FaInstagram />,
      url: "https://www.instagram.com/clideanalyser/",
      label: "Instagram",
      brandColor: "#E1306C",
    },
    {
      icon: <FaWhatsapp />,
      url: "https://whatsapp.com/channel/0029VaXX3MV9Gv7UaFTW823Z",
      label: "WhatsApp",
      brandColor: "#25D366",
    },
  ];

  return (
    <FooterContainer themeColor={themeColor}>
      <FooterContent>
        {!!socialMediaEnabled ? (
          <SocialSection>
            <SocialTitle>Follow Us</SocialTitle>

            <SocialIcons>
              {socialLinks.map((link, index) => (
                <IconLink
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  title={link.label}
                  $brandColor={link.brandColor}
                >
                  {link.icon}
                </IconLink>
              ))}
            </SocialIcons>
          </SocialSection>
        ) : (
          <div />
        )}

        <CopyrightSection>
          <Copyright>
            © {currentYear} CLIDE Management Consultancy Pvt. Ltd. All Rights
            Reserved
          </Copyright>
        </CopyrightSection>

        <RightSpacer />
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
